@if (isLoading) {
  <div [appLoading]="true"></div>
} @else {
  <div class="deposit-withdraw-forbid">
    <i origin class="fi-information-circle"></i>
    <p class="title">Access Restricted</p>
    <p class="text">
      You are not allowed to deposit or withdraw funds at this time. Please contact our support team for more details.
    </p>
    <div class="buttons">
      <cs-button (buttonClick)="contactSupport()" size="large" label="Contact Support"></cs-button>
    </div>
  </div>
}
